const ParticipantsSource = {
  PLAYBOOK: 'playbook',
  COMPANY: 'company',
};

export default ParticipantsSource;
